import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/** Shared Suspense fallback for route / panel lazy loads. */
export default function LazyFallback({ label = 'Loading…', fullPage = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1.75,
        minHeight: fullPage ? '100vh' : 240,
        width: '100%',
        py: fullPage ? 0 : 4,
        bgcolor: fullPage ? 'background.default' : 'transparent',
      }}
    >
      <CircularProgress
        size={fullPage ? 36 : 28}
        thickness={3.6}
        sx={{ color: 'primary.main' }}
      />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ letterSpacing: '-0.01em', fontWeight: 500 }}
      >
        {label}
      </Typography>
    </Box>
  );
}
